import * as React from 'react';
import {Breadcrumb, Grid, Input} from 'semantic-ui-react';
import i18n from '../../../../locale/i18n';
import {NavLink, withRouter, RouteComponentProps} from 'react-router-dom';
import {
  ColumnSelectableComponentProps,
  ColumnSortableComponentProps,
  FilterObjectComponentProps,
  InfinityScrollComponentProps,
  ViewSettingsComponentProps,
  withColumnSelection,
  withColumnSort,
  withFilterObject,
  withInfinityScrollHandlers, withPrintAndExport,
  withViewSettings
} from '../../components/DataTable/dataService';
import {DataTable} from '../../components/DataTable/DataTable';
import LoadingSpinner from '../../containers/LoadingContainer/LoadingSpinner';
import {ColumnDefinition} from '../../components/DataTable/common';
import {formatCurrency} from '../../utils/numbers';
import ContentContainer from '../../containers/ContentContainer/ContentContainer';
import {ColumnSelectionButton} from '../../components/DataTable/ColumnSelection';
import LoadingContainer from '../../containers/LoadingContainer/LoadingContainer';
import RestClient from '../../../../lib/RestClient';
import {default as DatePicker} from "react-datepicker/es";
import {dateToIsoDateString} from '../../utils/dates';
import {AnalyticsTracking} from "../../components/AnalyticsTracking/AnalyticsTracking";

const t = i18n.t.bind(i18n);

const getMarketName = (row: any) => {
  return (row.marktName && row.marktName[0] ? row.marktName[0] : '');
};

const COLUMNS: ColumnDefinition[] = [
  {
    fieldName: 'kunde',
    labelTranslationKey: 'Sales.kunde',
    required: true,
    cellRender: (_, row, filter) => {
      let searchParams = '?';
      if(filter && filter.dateFrom) {
        searchParams += '&dateFrom=' + encodeURIComponent(filter.dateFrom);
      }
      if(filter && filter.dateTo) {
        searchParams += '&dateTo=' + encodeURIComponent(filter.dateTo);
      }

        if (row.markt === t("Sales.sum"))
            return (<b>{_}</b>);

        if (_ === t("Sales.sum"))
            return (<b>{t("Sales.sum")}:</b>);


        return (
          <NavLink
              to={`/sales/customer/${row.kunde}/${row.markt}${searchParams}`}>{row.kunde}</NavLink>
      )}
  },
  {
    fieldName: 'markt',
    labelTranslationKey: 'Sales.markt',
    required: true,
    cellRender: (_, row, filter) => {
      let searchParams = '?';
      if(filter && filter.dateFrom) {
        searchParams += '&dateFrom=' + encodeURIComponent(filter.dateFrom);
      }
      if(filter && filter.dateTo) {
        searchParams += '&dateTo=' + encodeURIComponent(filter.dateTo);
      }

        if (_ === t("Sales.sum"))
            return (<b>{t("Sales.sum")}:</b>);

        if (_ === "")
            return _;

      return (
          <NavLink
              to={`/sales/customer/${row.kunde}/${row.markt}${searchParams}`}>{row.markt} {getMarketName(row)}</NavLink>
      );
    },
    printExportRender: (v,r) => v + ' ' + getMarketName(r)
  },
  {fieldName: 'gesamtAnz', labelTranslationKey: 'Sales.gesamtAnz', cellAlign: 'right'},
  {
    fieldName: 'gesamtPreis',
    labelTranslationKey: 'Sales.gesamtPreis',
    cellAlign: 'right',
    cellRender: v => formatCurrency(v),
    printExportRender: v => formatCurrency(v),
  }
];

const getScrollParent = () => ContentContainer.instance.componentRef.current;

let maxDate = "";

const DEFAULT_COLUMNS = COLUMNS.map(c => c.fieldName);

// TODO move to state / initializer of component so that no F5 is needed when day changes while application is loaded
const TODAY = new Date();

const PageComponent = (props: RouteComponentProps & InfinityScrollComponentProps & ColumnSelectableComponentProps & ColumnSortableComponentProps & FilterObjectComponentProps & ViewSettingsComponentProps) => {
  if(props.loadingInitial) {
    return <LoadingContainer showLogo={false}/>;
  }
  return (
      <>
        <AnalyticsTracking page="sales/customer" />
        <div className={"sticky-header"}>
          <div className={"ui container"}>
            <h3><Breadcrumb icon="right angle" sections={[
              {
                key: '1',
                as: NavLink,
                to: '/sales/customer',
                content: `${t("Route.Sales")} ${t("Route.SalesCustomer")}`, link: true
              }
            ]}/></h3>
            <p>{t("Common.Found$dDatasets", {count: props.totalItems})}</p> <br/>
            <Grid columns={5} className={"HeadingGrid"} stackable={true}
                  style={{marginBottom: '1em'}}>
              <Grid.Column width={4}>
                <Input fluid icon={'search'} placeholder={t("Forms.Placeholder.Search")} disabled={props.loading}
                       value={props.filterObject.filter} onChange={(_,data) => props.handleFilterChange('filter', data.value)}/>
              </Grid.Column>
              <Grid.Column width={4}>
                <DatePicker
                    className={"fluid"}
                    selected={props.filterObject.dateFrom ? new Date(props.filterObject.dateFrom) : TODAY || undefined}
                    onChange={(date: Date) => props.handleFilterChange('dateFrom', date ? date.toISOString() : undefined)}
                    dateFormat={t("Common.DateFormatPicker")}
                    placeholderText={t("Common.DateFrom")}
                    //minDate={minDate || TODAY}
                    //maxDate={props.filterObject.dateTo ? new Date(props.filterObject.dateTo) : maxDate || TODAY}
                    isClearable={true}
                />
              </Grid.Column>
              <Grid.Column width={4}>
                <DatePicker
                    className={"fluid"}
                    selected={props.filterObject.dateTo ? new Date(props.filterObject.dateTo) : maxDate || undefined}
                    onChange={(date: Date) => props.handleFilterChange('dateTo', date ? date.toISOString() : undefined)}
                    dateFormat={t("Common.DateFormatPicker")}
                    placeholderText={t("Common.DateTo")}
                    //minDate={props.filterObject.dateFrom ? new Date(props.filterObject.dateFrom) : minDate || undefined}
                    //maxDate={maxDate || TODAY}
                    isClearable={true}
                />
              </Grid.Column>
              <Grid.Column width={3}>
                <ColumnSelectionButton
                    fluid
                    availableColumns={COLUMNS}
                    selectedColumns={props.selectedColumns}
                    onSave={props.updateSelectedColumns}/>
              </Grid.Column>
                <Grid.Column width={1}>
                    <div style={{opacity: (props.loading) ? '1.0' : '0.0', width:"100%"}}>
                        <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
                        </div>
                    </div>
                </Grid.Column>
            </Grid>
          </div>
        </div>


        <div className={"ui container responsivewrapper"}>
          <DataTable
              columns={COLUMNS}
              data={props.data}
              page={props.page}
              totalPages={0}
              sortDirection={props.sortDirection}
              sortColumn={props.sortColumn}
              selectedColumns={props.selectedColumns}
              getScrollParent={getScrollParent}
              loadMore={props.loadMore}
              handleSortChange={props.handleSortChange}
              loading={props.loading}
              filter={props.filterObject}
          />
          <div style={{opacity: props.loadingMore ? '1.0' : '0.0'}}>
            <div style={{textAlign: 'center', height: '3em', marginTop: '1.5em'}}><LoadingSpinner/>
            </div>
          </div>
          <div style={{height: '2em'}}/>
        </div>
      </>
  )
};

const dataService = {
  loadPage(page: number, sortColumn: string, sortOrder: 'ASC' | 'DESC', filter: { [p: string]: any }, size?: number): Promise<any> {

      return new Promise((resolve, reject) => {
          RestClient.get('sales/customer', {
              date: '',
              filter: filter.filter || '',
              dateFrom: filter.dateFrom ? dateToIsoDateString(new Date(filter.dateFrom)) : '',
              dateTo: filter.dateTo ? dateToIsoDateString(new Date(filter.dateTo)) : '',
              sortBy: sortColumn,
              sortDirection: sortOrder,
              page: page,
              count: size || 50
          }).then( (data: any) => {

              maxDate = data.data.content.maxDatum;
              let rawKundenData: any[] = data.data.content.kundenData;

              let gesamtPreis = 0;
              let gesamtAnz = 0;

              let kundenData = rawKundenData.map( (dataRow: any ) => {
                  gesamtPreis += dataRow.gesamtPreis;
                  gesamtAnz += dataRow.gesamtAnz;

                  dataRow.marktData.push(
                      {
                          kunde: dataRow.kunde,
                          markt: t("Sales.sum"),
                          gesamtAnz: dataRow.gesamtAnz,
                          gesamtPreis: dataRow.gesamtPreis
                      }
                  );

                  return  dataRow.marktData;
              });

              data.data.content = kundenData.flat(1);

              data.data.content.push(
                  {
                      kunde: t("Sales.sum"),
                      markt: "",
                      gesamtAnz: gesamtAnz,
                      gesamtPreis: gesamtPreis
                  }
              );

              resolve(data);

          }, reject );
      });

  }

};

const PageComponentWrapped = withRouter(withViewSettings(withFilterObject(withColumnSort(withColumnSelection(withPrintAndExport(withInfinityScrollHandlers(PageComponent)))))));

export default () => (
    <PageComponentWrapped
        viewName="sales_summary_customer"
        dataService={dataService}
        defaultSortDirection="ASC"
        defaultSortColumn="kunde"
        defaultColumns={DEFAULT_COLUMNS}
        defaultFilter={{
            dateFrom: TODAY.toISOString()
        }}
        printColumns={COLUMNS}
        printPath={[`${t("Route.Sales")} ${t("Route.SalesCustomer")}`]}
    />
);
